<template>
    <transition name="fade">
        <div class="VirtualContractDocumentsWidget__Component" v-if="!isInitiating">
            <div v-if="ready">
                <button @click="showDocument" v-if="show">הצג מסמך</button>
                <span v-if="!hasDocument && !isLoading">לא קיים מסמך</span>
            </div>
            <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false"></b-loading>
        </div>
    </transition>
</template>

<script>
import VehicleService from '../../services/VehicleService';

export default {
    name: 'VirtualContractDocumentsWidget',
    props: ['ready', 'namespace', 'query', 'widget'],
    computed: {
        show() {
            return this.hasDocument && !this.isInitiating && !this.isLoading;
        },
        hasDocument() {
            return this.$store.state.virtualContract[`Has${this.widget.documentType}`];
        },
        contractId() {
            return this.$store.state.virtualContract.Id;
        },
    },
    data() {
        return {
            html: null,
            isInitiating: true,
            isLoading: false,
        };
    },
    methods: {
        showDocument() {
            this.$iframe.open({
                html: this.html,
                type: this.widget.documentType,
                readOnly: true,
                // read-only: closing only, no save
                onSave: async ({ close }) => {
                    close();
                },
            });
        },
        async init() {
            if (this.widget.documentType) {
                if (this.hasDocument) {
                    VehicleService
                        .getVirtualContractDocument(this.contractId, this.widget.documentType)
                        .then((r) => {
                            this.html = r.data;
                        })
                        .finally(() => {
                            this.$emit('onReady');
                            this.isInitiating = false;
                        });
                } else {
                    this.$emit('onReady');
                    this.isInitiating = false;
                }
            }
        },
    },
    watch: {
        ready(newValue) {
            if (newValue) {
                this.init();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    .VirtualContractDocumentsWidget__Component {
        width: 100%;
        min-height: 60px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;

        & > div {
            display: flex;
            width: 100%;
            justify-content: center;
        }

        button {
            border: none;
            background-color: transparent;
            text-align: center;
            width: 100%;
            color: #06c;
            cursor: pointer;

            &:hover {
                text-decoration: underline;
            }
        }
    }
</style>
